export interface CommunityComment {
  id: string;
  user: string;
  avatarClass: string;
  time: string;
  content: string;
  likes: number;
}

export interface CommunityPost {
  id: string;
  title: string;
  excerpt: string;
  cover: string;
  category: string;
  categoryName: string;
  author: string;
  authorRole: string;
  publishedAt: string;
  views: number;
  commentCount: number;
  heat: number;
  tags: string[];
  content: string[];
  comments: CommunityComment[];
}

export interface CommunityCategory {
  key: string;
  name: string;
  icon: string;
  desc: string;
  postCount: number;
}

export interface CommunityTopic {
  rank: number;
  title: string;
  category: string;
  categoryName: string;
  heat: number;
  replyCount: number;
  trend: "up" | "down" | "new";
  postId: string;
}

export interface CommunityFaq {
  question: string;
  answer: string;
}

export interface CommunityTestimonial {
  name: string;
  role: string;
  avatarClass: string;
  content: string;
}

export const siteMeta = {
  name: "爆料社区",
  slogan: "热点不迟到，吃瓜有秩序",
  intro:
    "爆料社区是一个以热度信号为核心的中文讨论聚合站，把今日活跃话题、高互动爆料帖与新帖热门讨论集中到一处，帮你在最短时间里找到值得围观的讨论。",
  email: "contact@baoliaoshequ.cn",
  workingHours: "周一至周日 09:00 - 23:00",
  foundedAt: "2023",
};

export const heroStats = [
  { label: "今日活跃话题", value: "1,286", icon: "ri-fire-line" },
  { label: "高互动爆料帖", value: "472", icon: "ri-chat-smile-2-line" },
  { label: "在线围观用户", value: "38,904", icon: "ri-group-line" },
  { label: "平均回复时长", value: "6 分钟", icon: "ri-timer-flash-line" },
];

export const categories: CommunityCategory[] = [
  {
    key: "insider",
    name: "内幕爆料",
    icon: "ri-alarm-warning-line",
    desc: "来自一线的匿名投稿，聚焦行业内部的真实见闻与细节线索。",
    postCount: 186,
  },
  {
    key: "entertainment",
    name: "娱乐八卦",
    icon: "ri-movie-2-line",
    desc: "片场路透、剧集口碑与幕后备料，围观前先看这里。",
    postCount: 254,
  },
  {
    key: "workplace",
    name: "职场内幕",
    icon: "ri-briefcase-4-line",
    desc: "招聘、加班、离职与团队故事，职场人的集体树洞。",
    postCount: 312,
  },
  {
    key: "tech",
    name: "科技数码",
    icon: "ri-cpu-line",
    desc: "新品参数、行业动态与体验反馈，理性讨论不吵架。",
    postCount: 148,
  },
  {
    key: "life",
    name: "生活百态",
    icon: "ri-cup-line",
    desc: "消费体验、城市见闻与生活细节，最接地气的话题聚集地。",
    postCount: 276,
  },
  {
    key: "emotion",
    name: "情感树洞",
    icon: "ri-heart-3-line",
    desc: "关系困惑与情绪出口，欢迎温柔而真诚的讨论。",
    postCount: 163,
  },
];

export const hotTopics: CommunityTopic[] = [
  {
    rank: 1,
    title: "连锁奶茶门店被指使用临期原料，品牌方连夜回应",
    category: "life",
    categoryName: "生活百态",
    heat: 98420,
    replyCount: 2367,
    trend: "up",
    postId: "naicha-linlinliao",
  },
  {
    rank: 2,
    title: "连续三个月大小周之后，他把凌晨的工位照片发了出来",
    category: "workplace",
    categoryName: "职场内幕",
    heat: 91250,
    replyCount: 1988,
    trend: "up",
    postId: "dachang-daxiaoZhou",
  },
  {
    rank: 3,
    title: "热播剧片场路透流出，网友直呼与正片差距太大",
    category: "entertainment",
    categoryName: "娱乐八卦",
    heat: 87630,
    replyCount: 1742,
    trend: "new",
    postId: "ju-zu-lu-tou",
  },
  {
    rank: 4,
    title: "反向旅游刷屏：年轻人放弃热门景区涌向小城",
    category: "life",
    categoryName: "生活百态",
    heat: 79310,
    replyCount: 1502,
    trend: "up",
    postId: "fanxiang-lvyou",
  },
  {
    rank: 5,
    title: "发布会前夕参数表流出，这代新机升级点被提前剧透",
    category: "tech",
    categoryName: "科技数码",
    heat: 74180,
    replyCount: 1286,
    trend: "new",
    postId: "fabu-hui-canshu",
  },
  {
    rank: 6,
    title: "秋招签了三方却被临时毁约，多名应届生讲述相似遭遇",
    category: "workplace",
    categoryName: "职场内幕",
    heat: 68940,
    replyCount: 1145,
    trend: "up",
    postId: "qiuzhao-huiyue",
  },
  {
    rank: 7,
    title: "团购套餐缩水引争议，网友晒出用餐前后对比照",
    category: "life",
    categoryName: "生活百态",
    heat: 62170,
    replyCount: 986,
    trend: "down",
    postId: "tuangou-suoshui",
  },
  {
    rank: 8,
    title: "合租矛盾冲上同城热榜：凌晨做饭该不该被投诉",
    category: "emotion",
    categoryName: "情感树洞",
    heat: 57320,
    replyCount: 842,
    trend: "up",
    postId: "hezu-lingchen",
  },
];

export const posts: CommunityPost[] = [
  {
    id: "naicha-linlinliao",
    title: "网友爆料：某连锁奶茶门店被指使用临期原料，店方公开回应",
    excerpt:
      "一条来自门店员工的匿名投稿引发关注，网友晒出的备料记录与排班表成为讨论焦点，品牌方随后发布说明。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cozy%20modern%20milk%20tea%20shop%20interior%20with%20wooden%20counter%20and%20soft%20amber%20lighting%2C%20stylized%20editorial%20illustration%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-naicha&orientation=landscape",
    category: "life",
    categoryName: "生活百态",
    author: "匿名用户 4721",
    authorRole: "某门店前员工",
    publishedAt: "2026-09-10 09:24",
    views: 128430,
    commentCount: 2367,
    heat: 98,
    tags: ["食品安全", "连锁品牌", "门店回应"],
    content: [
      "今天早上，一条来自门店员工视角的投稿在社区里被顶上了热榜。投稿人称，自己所在的连锁奶茶门店在客流高峰时段存在原料周转不及时的情况，并贴出了几张手写的备料记录。",
      "帖子发出两小时后，评论区开始出现另一种声音。有网友表示，单张记录无法证明系统性问题，也有自称同品牌其他门店的员工留言，称自己所在门店的效期管理一直比较严格，具体情况可能因店而异。",
      "中午前后，品牌方通过官方账号发布说明，表示已第一时间调取涉事门店的原料进出记录，并会公开阶段性核查结果。说明中还提到，将同步升级门店的效期提醒系统。",
      "截至发稿，这条帖子已经积累了超过两千条回复。社区提醒：围绕食品安全的讨论请以可核查的事实为基础，避免传播未经证实的门店信息。",
    ],
    comments: [
      {
        id: "c1",
        user: "隔壁桌的猫",
        avatarClass: "bg-primary-500",
        time: "2 小时前",
        content: "看记录确实有点可疑，但还是要等官方核查结果，别急着给所有门店扣帽子。",
        likes: 862,
      },
      {
        id: "c2",
        user: "柠檬不加冰",
        avatarClass: "bg-secondary-500",
        time: "1 小时前",
        content: "我就是做餐饮的，效期管理最怕高峰，制度是一回事，执行是另一回事。",
        likes: 517,
      },
      {
        id: "c3",
        user: "围观群众甲",
        avatarClass: "bg-accent-600",
        time: "48 分钟前",
        content: "希望说的是真话，别又是发个说明就没下文了。",
        likes: 344,
      },
    ],
  },
  {
    id: "dachang-daxiaoZhou",
    title: "大厂员工匿名发帖：连续三个月大小周，凌晨的工位照片看哭网友",
    excerpt:
      "一张凌晨两点、只亮着三盏台灯的办公区照片，让「大小周」这个话题再次被推到讨论中心。",
    cover:
      "https://readdy.ai/api/search-image?query=late%20night%20modern%20office%20workspace%20with%20glowing%20screens%20and%20city%20view%20through%20the%20window%2C%20warm%20amber%20and%20crimson%20tones%2C%20stylized%20editorial%20illustration%2C%20clean%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-office&orientation=landscape",
    category: "workplace",
    categoryName: "职场内幕",
    author: "匿名用户 9083",
    authorRole: "互联网从业者",
    publishedAt: "2026-09-10 08:12",
    views: 96420,
    commentCount: 1988,
    heat: 95,
    tags: ["职场", "加班", "大小周"],
    content: [
      "发帖人写道，自己所在的团队已经连续三个月执行大小周，最近两周更是因为版本上线延迟，把周末也算进了工作日。配图里，整层办公区只剩下零星几盏台灯。",
      "帖子下面，来自不同公司的网友开始分享自己的排班经历。有人提到所在团队实行弹性打卡，也有人直言，最难受的不是加班本身，而是计划被反复打乱之后那种无力感。",
      "一位做人力资源的网友在评论中给出了比较务实的建议：把加班时长、调休记录和实际到岗时间留存下来，与主管进行一次正式的沟通，会比在群里抱怨更有效。",
      "截至发稿，这条帖子仍在持续收到回复。社区也在帖子顶部加入了劳动者权益相关的科普链接，方便有需要的用户查阅。",
    ],
    comments: [
      {
        id: "c1",
        user: "把咖啡当水喝",
        avatarClass: "bg-primary-500",
        time: "3 小时前",
        content: "照片看着很熟悉，我们那层十点之前走的人基本没有。",
        likes: 731,
      },
      {
        id: "c2",
        user: "打工人小周",
        avatarClass: "bg-accent-600",
        time: "2 小时前",
        content: "建议把调休和打卡记录都存好，真到需要沟通的时候这些都是凭据。",
        likes: 602,
      },
      {
        id: "c3",
        user: "夜班观察员",
        avatarClass: "bg-secondary-500",
        time: "1 小时前",
        content: "比起加班，更想吐槽的是明明没那么多活，却非要耗到那个点。",
        likes: 455,
      },
    ],
  },
  {
    id: "ju-zu-lu-tou",
    title: "娱乐观察：某热播剧片场路透流出，网友直呼与正片差距太大",
    excerpt:
      "一组现场花絮被搬运到社区后迅速走红，讨论集中在打光、滤镜与成片调色之间的差距。",
    cover:
      "https://readdy.ai/api/search-image?query=film%20set%20studio%20with%20soft%20spotlights%20and%20camera%20silhouette%2C%20warm%20cinematic%20tones%2C%20stylized%20editorial%20illustration%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-filmset&orientation=landscape",
    category: "entertainment",
    categoryName: "娱乐八卦",
    author: "吃瓜研究所",
    authorRole: "内容整理者",
    publishedAt: "2026-09-09 21:40",
    views: 87310,
    commentCount: 1742,
    heat: 92,
    tags: ["剧集", "路透", "幕后"],
    content: [
      "这组路透最初出现在一个幕后工作人员的社交账号上，随后被搬运到社区。照片里，演员的妆造与灯光布置都和正片呈现有明显区别，网友的讨论也由此展开。",
      "有从事影视后期的网友解释说，成片会经过调色、补光和降噪等多道工序，现场的观感和最终播出效果本来就会存在落差，这属于正常流程的一部分。",
      "也有网友认为，讨论的焦点不该停留在「好不好看」，而是剧组在高强度拍摄下的通告安排是否合理。「路透能看到的只是十分钟，看不到的是连续十几天的大夜。」",
      "社区在帖子中补充说明：涉及具体剧组与演员的信息请以官方发布为准，请勿传播来源不明的私人影像。",
    ],
    comments: [
      {
        id: "c1",
        user: "追剧不熬夜",
        avatarClass: "bg-secondary-500",
        time: "5 小时前",
        content: "调色前后确实差挺多的，但这也是行业常态吧，不用上纲上线。",
        likes: 588,
      },
      {
        id: "c2",
        user: "片场盒饭",
        avatarClass: "bg-primary-500",
        time: "4 小时前",
        content: "真正该聊的是通告表，连着大夜谁都扛不住。",
        likes: 476,
      },
      {
        id: "c3",
        user: "路过的观众",
        avatarClass: "bg-accent-600",
        time: "3 小时前",
        content: "希望大家理性一点，别把搬运的私人影像当成实锤。",
        likes: 391,
      },
    ],
  },
  {
    id: "fabu-hui-canshu",
    title: "发布会前夕参数表流出：这代新机的升级点你猜到了吗",
    excerpt:
      "一张疑似内部培训资料的参数对比图在社区流传，屏幕、影像与续航成为讨论最集中的三个方向。",
    cover:
      "https://readdy.ai/api/search-image?query=sleek%20smartphone%20on%20a%20minimalist%20desk%20with%20warm%20gradient%20backdrop%2C%20stylized%20product%20editorial%20illustration%2C%20clean%20composition%2C%20amber%20and%20crimson%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-phone&orientation=landscape",
    category: "tech",
    categoryName: "科技数码",
    author: "数码早班车",
    authorRole: "数码爱好者",
    publishedAt: "2026-09-09 18:05",
    views: 74280,
    commentCount: 1286,
    heat: 88,
    tags: ["手机", "发布会", "参数"],
    content: [
      "距离发布会还有两天，一张疑似培训用的参数对比图在社区流传开来。从图中标注来看，新一代机型主要在屏幕亮度、影像算法和电池容量三个方向进行了调整。",
      "帖子下方的讨论很快分成了两派。一派认为这次的升级属于常规迭代，性价比一般；另一派则觉得，续航和散热才是日常体验的关键，参数好看与否反而是次要的。",
      "有网友贴出了上一代机型的使用报告作为对照，认为如果散热确实有改善，对长时间游戏和拍摄的用户来说会是比较实在的提升。",
      "需要提醒的是，目前流传的图片尚未得到官方确认，具体参数请以发布会现场公布的信息为准。",
    ],
    comments: [
      {
        id: "c1",
        user: "等等党永远不亏",
        avatarClass: "bg-accent-600",
        time: "6 小时前",
        content: "再等等，下半年还有一波新机，现在冲不划算。",
        likes: 512,
      },
      {
        id: "c2",
        user: "参数党老张",
        avatarClass: "bg-primary-500",
        time: "5 小时前",
        content: "屏幕亮度能上去就值得看，户外用起来差距很明显。",
        likes: 398,
      },
      {
        id: "c3",
        user: "轻度用户",
        avatarClass: "bg-secondary-500",
        time: "4 小时前",
        content: "我只关心续航和重量，别的都是浮云。",
        likes: 287,
      },
    ],
  },
  {
    id: "fanxiang-lvyou",
    title: "反向旅游刷屏：年轻人放弃热门景区，涌向这些小城",
    excerpt:
      "不挤人潮、不追网红点，越来越多的人把假期留给了没有攻略的小城，相关讨论一周内增长了近三倍。",
    cover:
      "https://readdy.ai/api/search-image?query=peaceful%20small%20ancient%20town%20street%20in%20early%20morning%20with%20warm%20sunlight%2C%20stylized%20editorial%20illustration%2C%20clean%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-town&orientation=landscape",
    category: "life",
    categoryName: "生活百态",
    author: "周末去哪儿",
    authorRole: "旅行分享者",
    publishedAt: "2026-09-09 15:30",
    views: 68120,
    commentCount: 1502,
    heat: 85,
    tags: ["旅行", "反向旅游", "小城"],
    content: [
      "「反向旅游」这个词最近频繁出现在社区里。和过去扎堆热门景区不同，这届年轻人更愿意挑一个没什么名气的小城，住上两三天，把节奏放慢。",
      "一位连续三年选择小城度假的网友分享了她的理由：预算更低、排队更少，最重要的是不用花大量时间在拍照和打卡上，「终于像个真正的假期」。",
      "也有网友提出了不同看法：小城的交通和配套相对有限，如果完全不做功课，很容易把假期浪费在找路上。他建议至少提前确认住宿位置和返程班次。",
      "帖子末尾整理了一份由社区用户共同补充的小城清单，涵盖交通方式、适合季节和大致花费，方便第一次尝试的人参考。",
    ],
    comments: [
      {
        id: "c1",
        user: "背着包就走",
        avatarClass: "bg-secondary-500",
        time: "8 小时前",
        content: "去年在一个人口不到二十万的小城待了四天，是我最放松的一次旅行。",
        likes: 623,
      },
      {
        id: "c2",
        user: "攻略爱好者",
        avatarClass: "bg-primary-500",
        time: "6 小时前",
        content: "小城确实舒服，但交通一定要提前查，不然容易卡在路上。",
        likes: 445,
      },
      {
        id: "c3",
        user: "不吃香菜",
        avatarClass: "bg-accent-600",
        time: "5 小时前",
        content: "求一份清单！最好带上适不适合带娃的信息。",
        likes: 318,
      },
    ],
  },
  {
    id: "tuangou-suoshui",
    title: "团购套餐缩水引争议，网友晒出用餐前后对比照",
    excerpt:
      "同一家店、同一个套餐，两份菜单的分量被网友放在一起对比，评论区吵成了两派。",
    cover:
      "https://readdy.ai/api/search-image?query=overhead%20flat%20lay%20of%20restaurant%20dishes%20and%20menu%20on%20a%20warm%20wooden%20table%2C%20stylized%20editorial%20food%20illustration%2C%20clean%20minimal%20composition%2C%20amber%20tones%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-meal&orientation=landscape",
    category: "life",
    categoryName: "生活百态",
    author: "干饭第一线",
    authorRole: "美食分享者",
    publishedAt: "2026-09-09 12:18",
    views: 59430,
    commentCount: 986,
    heat: 79,
    tags: ["消费", "团购", "餐饮"],
    content: [
      "发帖的网友表示，自己三个月内两次到访同一家餐厅，都点的是同款团购套餐，但第二次上桌的分量明显减少，于是拍下了对比照。",
      "评论区里，有人认为团购套餐本来就是引流款，分量调整属于商家的定价策略；也有人觉得，如果确实存在前后不一致，至少应该在页面标注清楚。",
      "一位餐饮从业者在留言中解释，团购套餐的成本结构通常会随着食材价格波动而调整，但规范的做法是在详情页同步更新菜品说明，而不是让顾客自己发现。",
      "社区建议遇到类似情况时先与门店沟通，协商无果可通过平台客服渠道反馈，并保留订单与菜品照片作为凭证。",
    ],
    comments: [
      {
        id: "c1",
        user: "干饭人小美",
        avatarClass: "bg-primary-500",
        time: "10 小时前",
        content: "对比照放一起确实挺明显的，希望商家能正面回应一下。",
        likes: 486,
      },
      {
        id: "c2",
        user: "餐饮老李",
        avatarClass: "bg-accent-600",
        time: "9 小时前",
        content: "成本涨了可以理解，但改菜单不说明就有点说不过去了。",
        likes: 372,
      },
      {
        id: "c3",
        user: "理性消费者",
        avatarClass: "bg-secondary-500",
        time: "7 小时前",
        content: "建议先跟店里沟通，实在不行再找平台，别一上来就差评。",
        likes: 254,
      },
    ],
  },
  {
    id: "qiuzhao-huiyue",
    title: "秋招签了三方却被临时毁约？多名应届生讲述相似遭遇",
    excerpt:
      "开学季的求职帖里，好几位应届生提到在同一个月收到了签约后的变动通知，话题迅速升温。",
    cover:
      "https://readdy.ai/api/search-image?query=graduation%20cap%20and%20resume%20documents%20on%20a%20desk%20with%20warm%20window%20light%2C%20stylized%20editorial%20illustration%2C%20clean%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-career&orientation=landscape",
    category: "workplace",
    categoryName: "职场内幕",
    author: "秋招记录员",
    authorRole: "校招信息整理者",
    publishedAt: "2026-09-08 20:45",
    views: 61380,
    commentCount: 1145,
    heat: 82,
    tags: ["校招", "应届生", "求职"],
    content: [
      "进入九月，社区里的秋招帖明显多了起来。其中一条整理帖汇总了多位应届生相似的经历：在签完三方之后，被告知岗位调整或流程延后。",
      "发帖人把几位同学的沟通记录做了脱敏处理，发现大家收到的说辞都比较接近，这也让不少围观的同学开始担心自己的签约进度。",
      "一位从事校园招聘的网友在评论中建议，签约前尽量确认岗位的具体归属部门和报到时间，同时留意协议中关于违约责任与违约金的条款。",
      "社区已将多位网友提到的维权渠道整理在帖子顶部，包括学校就业指导中心、平台投诉入口等，供有需要的同学参考。",
    ],
    comments: [
      {
        id: "c1",
        user: "准毕业生小林",
        avatarClass: "bg-accent-600",
        time: "1 天前",
        content: "看完有点慌，明天就去问清楚岗位和报到时间。",
        likes: 512,
      },
      {
        id: "c2",
        user: "HR同行",
        avatarClass: "bg-secondary-500",
        time: "1 天前",
        content: "签协议前把关键条款逐条看一遍真的很有必要。",
        likes: 398,
      },
      {
        id: "c3",
        user: "过来人老王",
        avatarClass: "bg-primary-500",
        time: "22 小时前",
        content: "遇到问题先找学校就业中心，比自己瞎着急有用多了。",
        likes: 301,
      },
    ],
  },
  {
    id: "dianying-dianying",
    title: "剧透预警：备受期待的电影提前点映，观众评价两极分化",
    excerpt:
      "点映场结束后，夸的夸到飞起，吐槽的也毫不客气，讨论主要集中在叙事节奏与结尾处理上。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20cinema%20seats%20and%20glowing%20screen%20in%20a%20warm%20dark%20hall%2C%20stylized%20editorial%20illustration%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-cinema&orientation=landscape",
    category: "entertainment",
    categoryName: "娱乐八卦",
    author: "银幕之后",
    authorRole: "影评整理者",
    publishedAt: "2026-09-08 16:20",
    views: 52910,
    commentCount: 1024,
    heat: 76,
    tags: ["电影", "点映", "口碑"],
    content: [
      "这部电影从立项起就话题不断，昨晚的首轮点映结束后，社区的观影帖一下子多了起来，评价呈现出明显的两极分布。",
      "给出好评的观众普遍提到画面的质感和演员的表演，「有几个长镜头是真的值回票价」；而给出中评的观众则认为中段节奏偏慢，结尾的处理略显仓促。",
      "也有网友提醒，点映场的观众本身就是兴趣更集中的人群，口碑未必能代表正式上映后的普遍反馈，建议等正式开分后再做判断。",
      "需要说明的是，本帖评论区关闭了关键剧情截图，希望还没看的朋友保留观影体验。",
    ],
    comments: [
      {
        id: "c1",
        user: "影迷一号",
        avatarClass: "bg-primary-500",
        time: "2 天前",
        content: "画面是真的好看，就是中间确实有点困。",
        likes: 442,
      },
      {
        id: "c2",
        user: "周末看电影",
        avatarClass: "bg-secondary-500",
        time: "2 天前",
        content: "我个人很喜欢结尾，见仁见智吧。",
        likes: 336,
      },
      {
        id: "c3",
        user: "等正式上映",
        avatarClass: "bg-accent-600",
        time: "1 天前",
        content: "谢谢楼里没剧透，我还能安心等到周末。",
        likes: 268,
      },
    ],
  },
  {
    id: "hezu-lingchen",
    title: "合租矛盾冲上同城热榜：凌晨做饭到底该不该被投诉",
    excerpt:
      "一条同城帖把合租里的边界问题重新拉回讨论中心，支持和反对的两方都讲出了自己的理由。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20shared%20apartment%20kitchen%20at%20night%20with%20warm%20lamp%20light%2C%20stylized%20editorial%20illustration%2C%20clean%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=baoliao-post-kitchen&orientation=landscape",
    category: "emotion",
    categoryName: "情感树洞",
    author: "树洞来信",
    authorRole: "社区倾诉区",
    publishedAt: "2026-09-08 11:02",
    views: 48760,
    commentCount: 842,
    heat: 72,
    tags: ["合租", "边界感", "同城"],
    content: [
      "发帖人住在一套三人合租的房子里，最近因为室友凌晨一点在厨房做饭，双方发生了争执。帖子发出后，同城话题迅速被顶了上来。",
      "支持发帖人的网友认为，合租房属于共享空间，深夜产生油烟和噪音确实会影响他人休息，提前沟通是基本礼貌。",
      "而站在另一边的人则觉得，如果厨房使用没有明确的时间约定，且对方已经尽量放轻动作，那么互相体谅也许比投诉更合适。",
      "一位经常处理合租纠纷的网友给出了折中方案：入住时就把公共区域的使用时间写成一份简单的约定，比事后争吵更能解决问题。",
    ],
    comments: [
      {
        id: "c1",
        user: "夜猫子室友",
        avatarClass: "bg-accent-600",
        time: "2 天前",
        content: "我站室友，凌晨做饭确实不太合适，哪怕再小心也会有声音。",
        likes: 371,
      },
      {
        id: "c2",
        user: "合租第三年",
        avatarClass: "bg-primary-500",
        time: "2 天前",
        content: "关键是没有约定，有约定的话谁都不会觉得委屈。",
        likes: 295,
      },
      {
        id: "c3",
        user: "温柔的旁观者",
        avatarClass: "bg-secondary-500",
        time: "1 天前",
        content: "好好说话比什么都强，合租本来就是互相妥协。",
        likes: 223,
      },
    ],
  },
];

export const contentPrinciples = [
  {
    icon: "ri-shield-check-line",
    title: "来源可追溯",
    desc: "每一篇进入热榜的爆料帖，都会标注投稿来源与发布时间，方便读者自行判断可信度。",
  },
  {
    icon: "ri-scales-3-line",
    title: "对立声音并存",
    desc: "我们鼓励在同一个话题下保留不同立场，评论区不按观点做单向筛选。",
  },
  {
    icon: "ri-user-heart-line",
    title: "保护当事人",
    desc: "涉及个人隐私的信息会被折叠处理，避免讨论演变成针对具体个人的攻击。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续跟进",
    desc: "热度高的帖子会被持续跟进，事件有了新进展会第一时间更新到原帖。",
  },
];

export const faqs: CommunityFaq[] = [
  {
    question: "爆料社区的内容都是从哪里来的？",
    answer:
      "社区内容主要由用户匿名投稿，经编辑整理后发布。每篇帖子都会标注投稿时间和来源类型，方便读者判断信息可信度。我们不对未经核实的内容作真实性背书。",
  },
  {
    question: "什么样的投稿会被推荐上今日活跃话题榜？",
    answer:
      "热榜综合了回复数量、互动速度和讨论持续时长等指标。一般来说，能在短时间内引发多角度讨论、且信息相对完整的帖子，更容易进入热榜前列。",
  },
  {
    question: "如何参与一个正在进行的讨论？",
    answer:
      "进入任意帖子的详情页，在评论区底部输入你的看法即可参与讨论。建议先浏览已有的高赞回复，避免重复表达相同观点。",
  },
  {
    question: "投稿时可以匿名吗？",
    answer:
      "可以。投稿表单中无需填写真实姓名，你可以选择匿名发布。我们仅会记录必要的联系方式，用于在需要补充信息时与你取得联系。",
  },
  {
    question: "发现帖子内容不实或侵犯隐私怎么办？",
    answer:
      "每篇帖子底部都提供举报入口，你也可以通过联系邮箱与我们沟通。收到反馈后，我们会优先核实并视情况对内容采取折叠、补充说明或下架处理。",
  },
  {
    question: "为什么有些热门帖子的评论区会被关闭？",
    answer:
      "当讨论明显偏离事实、出现大量人身攻击或涉及未成年人隐私时，我们会暂时关闭评论区，待完成信息核实后再决定是否重新开放。",
  },
  {
    question: "浏览和参与讨论需要注册账号吗？",
    answer:
      "浏览全部内容无需账号。参与评论、订阅话题更新与投稿则需要完成简单的注册，以便我们更好地维护讨论秩序。",
  },
  {
    question: "社区如何对内容板块进行划分？",
    answer:
      "目前分为内幕爆料、娱乐八卦、职场内幕、科技数码、生活百态与情感树洞六个板块。投稿时会先经过一次归类，你也可以在话题榜中按板块筛选查看。",
  },
];

export const testimonials: CommunityTestimonial[] = [
  {
    name: "林一舟",
    role: "连续浏览用户",
    avatarClass: "bg-primary-500",
    content: "以前找热点要在好几个平台之间来回切，现在打开热榜就能看到今天大家在聊什么，省事太多了。",
  },
  {
    name: "苏晚",
    role: "情感树洞常驻",
    avatarClass: "bg-secondary-500",
    content: "树洞区的氛围比我想象中温柔，大家是真的在认真回复，而不是单纯看热闹。",
  },
  {
    name: "何斯远",
    role: "科技数码板块读者",
    avatarClass: "bg-accent-600",
    content: "参数流出的帖子下面总有人做对照分析，比单纯喊口号有用，看完能形成自己的判断。",
  },
];

export const hotTags = [
  "食品安全",
  "大小周",
  "反向旅游",
  "校招签约",
  "剧集路透",
  "手机发布会",
  "合租边界",
  "团购套餐",
  "电影点映",
  "职场沟通",
];

export const siteHighlights = [
  { label: "覆盖板块", value: "6 大内容板块" },
  { label: "日均更新", value: "300+ 条新帖" },
  { label: "成立时间", value: "2023 年" },
  { label: "内容原则", value: "可追溯 · 多元声音" },
];